import type React from "react";
import { ReactComponent as Svg } from "./assets/replace.svg";
import * as styles from "./Icon.module.scss";

type ReplaceProps = React.SVGProps<SVGSVGElement>;

export const Replace = ({ className, ...props }: ReplaceProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
